var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"jibenWrap"},[_c('Heads'),_c('div',{staticClass:"jiben_content"},[_vm._v("\n        我是基本信息\n    ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }